import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, Heart, TrendingUp, Users, MapPin, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function CareerPage() {
  const navigate = useNavigate();

  const openings = [
    { title: 'Senior Backend Engineer', department: 'Engineering', location: 'Lagos', type: 'Full-time', level: 'Senior' },
    { title: 'Product Designer', department: 'Product', location: 'Remote', type: 'Full-time', level: 'Mid' },
    { title: 'Customer Success Manager', department: 'Operations', location: 'Lagos', type: 'Full-time', level: 'Mid' },
    { title: 'Compliance Officer', department: 'Legal', location: 'Lagos', type: 'Full-time', level: 'Senior' },
    { title: 'Growth Marketing Lead', department: 'Marketing', location: 'Lagos', type: 'Full-time', level: 'Senior' },
    { title: 'Data Analyst', department: 'Analytics', location: 'Remote', type: 'Full-time', level: 'Junior' }
  ];

  const benefits = [
    { icon: <TrendingUp className="w-8 h-8" />, title: 'Competitive Salary', desc: 'Industry-leading compensation packages' },
    { icon: <Heart className="w-8 h-8" />, title: 'Health Insurance', desc: 'Comprehensive coverage for you and family' },
    { icon: <Clock className="w-8 h-8" />, title: 'Flexible Hours', desc: 'Work-life balance is our priority' },
    { icon: <Users className="w-8 h-8" />, title: 'Learning & Growth', desc: 'Continuous training and development' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="pt-32 pb-20 px-4 md:px-8 bg-gradient-to-br from-purple-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <Briefcase className="w-16 h-16 text-purple-600 mx-auto mb-6" />
          <h1 className="text-5xl md:text-7xl font-bold font-heading text-slate-900 mb-6">
            Build The Future With Us
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Join a team of passionate innovators transforming African finance. We're looking for talented people who want to make a real impact.
          </p>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-12 text-center">Why Work at Britedge?</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {benefits.map((benefit, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 text-center">
                <div className="w-16 h-16 rounded-2xl bg-purple-100 text-purple-600 flex items-center justify-center mx-auto mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{benefit.title}</h3>
                <p className="text-slate-600 text-sm">{benefit.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-12 text-white text-center">
            <h3 className="text-3xl font-bold mb-4">Additional Perks</h3>
            <div className="grid md:grid-cols-3 gap-6 mt-8">
              {['Stock Options', 'Remote Work', 'Annual Retreats', 'Learning Budget', 'Gym Membership', 'Team Bonding'].map((perk, idx) => (
                <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <p className="font-semibold">{perk}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* <section className="py-20 px-4 md:px-8 bg-slate-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-4 text-center">Open Positions</h2>
          <p className="text-lg text-slate-600 mb-12 text-center">Join our growing team of 76 talented individuals</p>
          
          <div className="space-y-4">
            {openings.map((job, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:border-brand-blue transition-all">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-900 mb-2">{job.title}</h3>
                    <div className="flex flex-wrap gap-3 text-sm text-slate-600">
                      <span className="flex items-center gap-1">
                        <Briefcase className="w-4 h-4" />
                        {job.department}
                      </span>
                      <span className="flex items-center gap-1">
                        <MapPin className="w-4 h-4" />
                        {job.location}
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock className="w-4 h-4" />
                        {job.type}
                      </span>
                      <span className="px-2 py-1 bg-blue-100 text-brand-blue rounded-full text-xs font-semibold">
                        {job.level}
                      </span>
                    </div>
                  </div>
                  <Button className="bg-brand-blue text-white rounded-xl px-6 py-3 whitespace-nowrap">
                    Apply Now
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-purple-600 to-purple-700 rounded-3xl p-12 text-white text-center">
          <h2 className="text-4xl font-bold font-heading mb-6">Don't See Your Role?</h2>
          <p className="text-xl text-purple-100 mb-8">
            We're always looking for exceptional talent. Send us your resume and let's talk!
          </p>
          <Button 
            onClick={() => navigate('/contact')}
            className="bg-white text-purple-600 hover:bg-purple-50 rounded-full px-10 py-6 text-lg font-semibold"
          >
            Get In Touch
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
